import { Col, Layout, Row } from 'antd';
import styled from 'styled-components';
import { useHistory, withRouter } from 'react-router-dom';
import PageDropdown from './PageDropdown';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

const { Header, Content } = Layout;

const StyledDiv = styled(Layout)`
  .site-layout-content {
    min-height: 280px;
    padding: 24px;
    background: #fff;
  }
  .logo {
    /* width: 115px; */
    /* height: 21px; */
    font-size: 1.5rem;
    font-weight: bold;
  }
  .header {
    background: #fff;
    /* width: 1440px;
    height: 48px; */
    /* padding: 12px 24px 12px 27px; */
    /* box-shadow: 0 2px 6px 0 rgba(0, 21, 41, 0.12); */
  }
  .userMenu {
    margin-right: 30px;
  }

  .serviceMenu {
    margin-right: 30px;
  }
`;

interface PageHeaderProps {
  children?: React.ReactNode;
}

function PageHeader({ children }: PageHeaderProps) {
  let history = useHistory();
  const user = useSelector((state: RootState) => state.auth.auth.data);

  const goToMainPage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/main`);
  };

  return (
    <StyledDiv>
      <Header className="header">
        <Row justify="space-between">
          <Col>
            {/* <span>하이공사</span> */}
            <a href="/#" onClick={(e) => goToMainPage(e)}>
              <img
                src={`${process.env.PUBLIC_URL}/img/higongsa_logo.png`}
                alt="higongsa_logo"
                style={{ width: '120px' }}
              />
            </a>
            {/* <img src={`/logo192.png`} alt="logo192" /> */}
          </Col>
          {/* <Col>
            <h2>{user?.myEnterprise.name}</h2>
          </Col> */}
          <Col>
            <PageDropdown />
          </Col>
        </Row>
      </Header>
      <Content className="site-layout-content">{children}</Content>
    </StyledDiv>
  );
}

export default withRouter(PageHeader);
